import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// Informational cookie notice. Dynalink sets only a strictly-necessary
// auth cookie (refresh_token) and no analytics/third-party cookies, so under
// the ePrivacy rules an informational banner suffices — there is nothing to
// opt in or out of. If tracking cookies are ever added, this must become a
// real consent gate.
const DISMISS_KEY = 'cookieNoticeDismissed';

const CookieNotice = () => {
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === '1');

  if (dismissed) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:max-w-md z-50">
      <div className="rounded-xl border border-ink-200 bg-white shadow-lg p-4 flex items-start gap-3">
        <div className="text-sm text-ink-700">
          We use a single sign-in cookie that's strictly necessary for the service — no tracking,
          no ads. Details in our{' '}
          <Link to="/privacy" className="text-brand-600 underline" onClick={dismiss}>Privacy Policy</Link>.
        </div>
        <button
          type="button"
          onClick={dismiss}
          className="shrink-0 rounded-lg bg-ink-900 text-white text-xs font-medium px-3 py-1.5 hover:bg-ink-700"
        >
          Got it
        </button>
      </div>
    </div>
  );
};

export default CookieNotice;
